<template>
    <v-dialog v-model="dialog" max-width="90%">
        <app-card>
            <app-section-loader :status="loading.submit"></app-section-loader>
            <h4>CHỈNH SỬA ĐĂNG KÝ INTERNET</h4>
            <p class="fs-14 grey--text">Chỉnh sửa thông tin</p>
            <v-form ref="form">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12 md4>
                            <v-select label="Tòa nhà" v-model="internet_user.building"
                                :items="list_building" item-text="text" item-value="value" :disabled="loading.submit"
                                prepend-icon="business"></v-select>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-select label="Phòng" v-model="internet_user.room_id" :items="room_ids"
                                item-text="room_id" item-value="room_id" :disabled="loading.submit"
                                prepend-icon="room"></v-select>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field label="Giá thu khách hàng" v-model="internet_user.customer_price"
                                prepend-icon="money" v-currency></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Số người ở" v-model="internet_user.number_of_residents"
                                prepend-icon="people" type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field 
                                label="Số chứng từ giấy" 
                                v-model="internet_user.receipt_code"
                                prepend-icon="receipt"
                                :disabled="loading.submit"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field 
                                label="Mã chứng từ" 
                                v-model="internet_user.receipt_id"
                                prepend-icon="receipt_long"
                                :disabled="true"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-menu :close-on-content-click="false" v-model="menu_registration_date"
                                :nudge-right="40" lazy transition="scale-transition" offset-y full-width
                                min-width="290px">
                                <v-text-field slot="activator" v-model="internet_user.registration_date"
                                    label="Ngày đăng ký" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker locale="vi-VI" v-model="internet_user.registration_date"
                                    @input="menu_registration_date = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field label="Phương án lắp đặt"
                                v-model="internet_user.installation_plan"
                                prepend-icon="build"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
                            <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeDialog">Hủy</v-btn>
                    <v-btn @click="saveEdit" color="primary">Lưu</v-btn>
                </v-card-actions>
        </app-card>
    </v-dialog>
</template>

<script>
import api from "Api";
import { list_building } from "Constants/db-config";
import { parseCurrency } from "Helpers";

export default {
    name: "edit-internet-registration",
    props: {
        internet_user: {
            type: Object,
            default: () => ({})
        },
        dialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            list_building,
            menu_registration_date: false,
            menu_date_start: false,
            loading: {
                submit: false
            }
        }
    },
    computed: {
        rooms() {
            return this.$store.state.app.rooms;
        },
        room_ids() {
            return this.rooms.filter(room => room.building === this.internet_user.building);
        }
    },
    watch: {
        dialog(nv) {
            if (nv) {
                const user = { ...this.internet_user };
                if (user.registration_date) user.registration_date = user.registration_date.substring(0, 10);
                if (user.date_start) user.date_start = user.date_start.substring(0, 10);
                
                if (user.receipt_code) user.receipt_code = user.receipt_code;
                
                if (!user.customer_price && user.price) {
                    user.customer_price = user.price;
                }
                
                this.internet_user = user;
            }
        },
        "internet_user.receipt_code"(nv) {
            if (nv && this.internet_user.building) {
                const buildingCode = this.internet_user.building === 'MT' ? 'MA' : this.internet_user.building;
                this.internet_user.receipt_id = buildingCode + '.' + nv + ".MA";
            }
        },
        "internet_user.building"(nv) {
            if (nv && this.internet_user.receipt_code) {
                const buildingCode = nv === 'MT' ? 'MA' : nv;
                this.internet_user.receipt_id = buildingCode + '.' + this.internet_user.receipt_code + ".MA";
            }
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close');
        },
        async saveEdit() {
            try {
                const postData = {
                    customer_price: parseCurrency(this.internet_user.customer_price, "vi-VN", 'VND'),
                    number_of_residents: this.internet_user.number_of_residents ? Number(this.internet_user.number_of_residents) : 1,
                    installation_plan: this.internet_user.installation_plan,
                    registration_date: this.internet_user.registration_date,
                    note: this.internet_user.note,
                    building: this.internet_user.building,
                    room_id: this.internet_user.room_id,
                    receipt_code: this.internet_user.receipt_code,
                    receipt_id: this.internet_user.receipt_id,
                };
                
                this.loading.submit = true;
                await api.updateInternet(this.internet_user._id, postData);
                this.loading.submit = false;
                
                swal.fire('Thành công', 'Đã cập nhật thông tin', 'success');
                this.$emit('close');
                this.$emit('reload');
            } catch (error) {
                this.loading.submit = false;
                console.error("Save edit error:", error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi lưu', 'error');
            }
        }
    }
}
</script> 